import { render, staticRenderFns } from "./subscribe.vue?vue&type=template&id=1a887d62&scoped=true&"
import script from "./subscribe.vue?vue&type=script&lang=js&"
export * from "./subscribe.vue?vue&type=script&lang=js&"
import style0 from "./subscribe.vue?vue&type=style&index=0&id=1a887d62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a887d62",
  null
  
)

export default component.exports